import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function Home() {
  return (
    <div className="md:flex min-h-screen">
      <Sidebar />
      <main className="md:w-3/5 xl:w-4/5 p-8">
        {/* Aquí se renderizan las rutas hijas de /admin */}
        <Outlet />
      </main>
    </div>
  );
}
